import { render, staticRenderFns } from "./StudentAccount.vue?vue&type=template&id=3ce6e696&scoped=true&"
import script from "./StudentAccount.vue?vue&type=script&lang=js&"
export * from "./StudentAccount.vue?vue&type=script&lang=js&"
import style0 from "./StudentAccount.vue?vue&type=style&index=0&id=3ce6e696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce6e696",
  null
  
)

export default component.exports